export default {
    'name': 'caret-light',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M18.4872 16.1164C18.7801 16.4093 19.255 16.4093 19.5479 16.1164C19.8408 15.8235 19.8408 15.3486 19.5479 15.0557L12.5302 8.03803C12.3896 7.89738 12.1988 7.81836 11.9999 7.81836C11.801 7.81836 11.6102 7.89738 11.4696 8.03803L4.45191 15.0557C4.15902 15.3486 4.15902 15.8235 4.45191 16.1164C4.7448 16.4093 5.21968 16.4093 5.51257 16.1164L11.9999 9.62902L18.4872 16.1164Z\' fill=\'#026958\'/>'
}
